import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useL10n, useSexOptions } from '@uplift/hooks';
import {
  DateOfBirthInput, PillRadioButton, PillRadioButtonGroup, StandaloneAddressQuickSearchForm,
  TextInput
} from '@uplift/ui-v2';

export const AboutYouForm: React.VFC = () => {
  const l10n = useL10n();
  const { classes, cx } = useAboutYouFormStyles();
  const { sexOptions } = useSexOptions(l10n);

  return (
    <div>
      <Box display="flex" flexDirection="column" gap="1.5rem">
        <PillRadioButtonGroup
          name="sex"
          label={l10n.onboarding.account.sex}
          helperText={l10n.onboarding.account.binary}
        >
          {sexOptions.map(x => <PillRadioButton label={x.label} value={x.value} key={x.value} testId={`sex-${x.value}`} />)}
        </PillRadioButtonGroup>
        <TextInput
          trim
          id="pronouns"
          name="pronouns"
          label={l10n.onboarding.account.pronouns}
          className={classes.pronouns}
        />
        <DateOfBirthInput
          name="dateOfBirth"
          label={l10n.onboarding.account.dateOfBirth}
          helperText={l10n.matching.insurance.dateOfBirthTip}
          id="date-of-birth"
          className={cx([ classes.formControl ])}
          // put class here so that helper text doesn't wrap
          inputClasses={{
            root: classes.dob,
          }}
        />
        <Typography variant="overline" color="secondary" component="p">
          {l10n.matching.payment.contactInfo}
        </Typography>


        <Box display="flex" flexDirection="column" gap="1rem">
          <Typography component="b" fontWeight={500} variant="body2" color="textPrimary">To follow safety regulations, please enter your home address.</Typography>
          <Typography variant="body2" color="textPrimary">Whether it’s a temporary on-campus address or your primary residence, it’s important your address matches where you are now.</Typography>
        </Box>

        <StandaloneAddressQuickSearchForm
          label="Home Address"
          getFieldName={(key) => `address.${key}`}
        />
      </Box>
    </div>
  );
};

const useAboutYouFormStyles = makeStyles({ name: 'AboutYouForm' })(theme => ({
  formControl: {
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '75%',
      minWidth: '400px'
    },
  },
  pronouns: {
    marginBottom: theme.spacing(3),
    width: '250px'
  },
  dob: {
    width: '121px',
    minWidth: 'initial'
  },
  phone: {
    display: 'block',
    width: '170px',
  },
}));
